<div class="wellness-popup-overlay" *ngIf="notification" (click)="onOverlayClick()">
  <div class="wellness-popup" (click)="$event.stopPropagation()">
    <div class="wellness-popup-header">
      <div class="wellness-popup-header-content">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        <span class="font-primary--b">{{ 'wellness.popup.header' | translate }}</span>
      </div>
      <button class="wellness-popup-close" (click)="onClose()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    <div class="wellness-popup-body">
      <p class="popup-student-name">{{ notification.studentName }}</p>
      <p class="popup-class-name">{{ notification.className }}</p>
      <p class="popup-date">{{ formatNotificationDate(notification.date) }}</p>

      <div class="popup-signal">
        <p class="popup-signal-label">{{ 'wellness.popup.signal-type' | translate }}</p>
        <p class="popup-signal-value">
          "{{ notification.trigger_translation }}"
        </p>
      </div>

      <button *ngIf="showProfileButton" class="popup-profile-btn font-primary--b" (click)="onGoToProfile()">
        {{ 'wellness.popup.go-to-profile' | translate }}
      </button>
    </div>
  </div>
</div>
